export default __webpack_public_path__ + "static/media/Landing2.43384f89.jpg";